import './HomePage.scss';
import React, { useState, useEffect } from 'react';
import screenshot from '../assets/img/background.png';
import icon from '../assets/img/icon.png';
import qrcode from '../assets/img/qrcode.png';
import scan from '../assets/img/scan.png';

function HomePage() {
  const [scrolling, setScrolling] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleLocateToAppStore = () => {
    window.open('https://apps.apple.com/us/app/talkinvoice/idYOUR_APP_ID', '_blank');
  };

  const handleContactSupport = () => {
    const recipient = 'talkinvoice.support@geniustech.ai';
    const subject = 'Feedback';
    const body = 'Please describe your issue here...';
    const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink);
  };

  return (
    <div className="App">
      <header className={scrolling ? 'header header-scrolled' : 'header'}>
        <div className="container">
          <div className="navL">
            <span className="brand">TalkInvoice</span>
          </div>
          <div className="navR">
            {/* 临时隐藏，等产品上线后再启用 */}
            <div className="store" onClick={handleLocateToAppStore} style={{ display: 'none' }}>
              App Store
            </div>
            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ backgroundColor: isHovered ? '#171717' : '#171717', display: 'none' }}
              className="download"
            >
              Download
              {isHovered && (
                <div className="qrCode">
                  <div className="triangle">
                    <img src="./triangle.png" alt="" />
                  </div>
                  <div className="qrcode">
                    <img src={qrcode} alt="" />
                  </div>
                  <div className="text">
                    <div>
                      <img src={scan} alt="" />
                    </div>
                    <div>Scan to download</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      <div className="section">
        <div className="left">
          <img src={screenshot} alt="" />
        </div>
        <div className="right">
          <div className="icon">
            <img src={icon} alt="" />
          </div>
          <div className="name">TalkInvoice</div>
          <div className="desc">
            Generate professional invoices with your voice. TalkInvoice turns natural speech into
            ready-to-send invoices in seconds — just say the client, items, quantities, and prices,
            and let AI handle the formatting, totals, and tax. Save hours on billing every week,
            send invoices on the go, and keep your cash flow moving with hands-free invoicing.
          </div>
          <div className="contact">
            For inquiries or support, contact email:{' '}
            <a href="mailto:talkinvoice.support@geniustech.ai">talkinvoice.support@geniustech.ai</a>
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="footerL">
            <div className="title">TalkInvoice</div>
            <div className="copyright">2026 © GENIUS AI LABS PTE. LTD. All Rights Reserved.</div>
          </div>
          <div className="footerR">
            <div className="item">
              <a href="/privacy.pdf" target="_blank" rel="noreferrer">
                Privacy Policy
              </a>
            </div>
            <div className="item">
              <a href="/terms.pdf" target="_blank" rel="noreferrer">
                Terms of Use
              </a>
            </div>
            <div className="item">
              <div className="link" onClick={handleContactSupport}>
                Email
                <span style={{ color: '#FFFFFF66', marginLeft: '10px', fontSize: '12px' }}>
                  talkinvoice.support@geniustech.ai
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
